/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_One_Drive_ListInputs */

const es_tools_one_drive_list = /** @type {(inputs: Tools_One_Drive_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listando carpeta de OneDrive...`)
};

const en_tools_one_drive_list = /** @type {(inputs: Tools_One_Drive_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing OneDrive folder...`)
};

/**
* | output |
* | --- |
* | "Listing OneDrive folder..." |
*
* @param {Tools_One_Drive_ListInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_one_drive_list = /** @type {((inputs?: Tools_One_Drive_ListInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_One_Drive_ListInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_one_drive_list(inputs)
	return en_tools_one_drive_list(inputs)
});
export { tools_one_drive_list as "tools.one_drive.list" }